import { useCallback } from 'react';
import { trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';

const useTrackFullscreenClicked = () => {
  const { productEvents } = useConfigContext();

  const trackCallback = useCallback(() => {
    const trackProductAnalytics = trackAnalytics(productEvents);
    trackProductAnalytics('Expanded', {
      Expanded: true,
    });
  }, [productEvents]);

  return trackCallback;
};

export default useTrackFullscreenClicked;
